<template>
  <div>
    <div class="text-center">
      <ProjectDetail v-if="currentProject" :project="currentProject">
        <template v-slot:return-button>
          <v-btn text small @click="to('home')">
            Regresar
          </v-btn>
        </template>
      </ProjectDetail>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProjectDetail from '@/components/normal/ProjectDetail'

export default {
  components: { ProjectDetail },
  props: {
    id: String
  },
  computed: {
    ...mapGetters('projectsRoot', ['getProjectById']),
    currentProject() {
      return this.getProjectById(this.id)
    }
  },
  methods: {
    to(name, params) {
      // console.log('to -> name', name)
      this.$router.push({ name, params })
    }
  }
}
</script>
